const r = {
  "cdr-form-error": "cdr-form-error_15-1-0",
  "cdr-form-error__icon": "cdr-form-error__icon_15-1-0",
  "cdr-form-group": "cdr-form-group_15-1-0",
  "cdr-form-group--error": "cdr-form-group--error_15-1-0",
  "cdr-form-group--disabled": "cdr-form-group--disabled_15-1-0",
  "cdr-form-group__optional": "cdr-form-group__optional_15-1-0",
  "cdr-form-group__required": "cdr-form-group__required_15-1-0",
  "cdr-form-group__wrapper": "cdr-form-group__wrapper_15-1-0"
};
export {
  r as default
};
